import { createSlice } from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage';
import { persistReducer } from 'redux-persist';
import { PERSIST_KEYS, STORE_SLICES } from '../../utils/enums';

import { reducers } from './reducers';
import { IRootState } from './type';

const initialState: IRootState = {
  selectedIntegration: {} as IRootState['selectedIntegration'],
  gustoData: [],
  activeStep: 0,
  gustoReportData: [],
  mgmReportData: [],
};

export const slice = createSlice({
  name: STORE_SLICES.PAYROLL,
  initialState,
  reducers,
});

const payrollActions = slice.actions;

const payrollPersistConfig = {
  key: PERSIST_KEYS.PAYROLL,
  storage,
  whitelist: ['gustoData'],
};

export {
  payrollActions,
};

export default persistReducer(payrollPersistConfig, slice.reducer);
